module.exports = __webpack_public_path__ + "img/categoria.7f628063.svg";